import { useDispatch, useSelector } from "react-redux";
import {
  actionUpdateCdRecovery,
  resetUpdateCdRecovery,
} from "../../routes/app/auth/employer/store";
import React, { useEffect, useState } from "react";
import {
  TOAST_DURATION,
  TOAST_ERROR_COLOR,
  TOAST_POSITION,
  TOAST_SUCCESS_COLOR,
} from "../../common/app_constant";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import ErrorLabel from "../error_label";
import { useForm } from "react-hook-form";
import $ from "jquery";

const AddCdRecovery = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm();
  const { UpdateCdRecovery } = useSelector((state) => ({
    ...state.employerStore,
  }));

  const [loading, setLoading] = useState(false)

  useEffect(() => {
    setValue(
      "cd_recovery_amount",
      props?.cdSelectedIds?.length == 1 ? props?.selectedDetails : ""
    );
  }, [props]);

  useEffect(() => {
    if (UpdateCdRecovery && props.isCdRecoveryModel) {
      dispatch(resetUpdateCdRecovery());
      $("#add_edit_cd_recovery").prop("disabled", false);
      if (UpdateCdRecovery.status === true) {
        setLoading(false)
        toast.success(UpdateCdRecovery.message, {
          duration: TOAST_DURATION,
          position: TOAST_POSITION,
          style: {
            color: TOAST_SUCCESS_COLOR,
          },
        });
        $("#app-body").removeClass("modal-open");
        $(".modal-backdrop").remove();
        setValue("cd_recovery_date", null);
        setValue("cd_recovery_amount", null);
        props.handleCdClose()
        window.location.reload()
      } else {
        setLoading(false)
        props.handleCdClose();
        switch (UpdateCdRecovery.status_code) {
        }
      }
    }
  }, [UpdateCdRecovery]);

  useEffect(() => {
    if (props.isCdRecoveryModel) {
      $("#app-body").addClass("modal-open");
      $("#app-body").append('<div class="modal-backdrop fade show"></div>');
    } else {
      $("#app-body").removeClass("modal-open");
      $(".modal-backdrop").remove();
    }
  }, [props.isCdRecoveryModel]);

  const onSubmit = (data) => {
    data.type = "policy";
    data.ids = props?.cdSelectedIds;
    data.cd_recovery_amount = Array.isArray(data.cd_recovery_amount) ? data.cd_recovery_amount[0] : data.cd_recovery_amount;
    $("#add-edit-cd-recovery-loader").removeClass("hidden");
    $("#add_edit_cd_recovery").prop("disabled", true);
    dispatch(actionUpdateCdRecovery({ ...data }));
    setLoading(true)
  };

  return (
    <>
      {/* bcoz of fade class in modal its not working */}
      <div
        class="modal"
        id="cd_recovery"
        tabindex={-1}
        data-bs-backdrop="static"
        aria-labelledby="cd_recovery"
        aria-hidden="true"
        style={{ display: props.isCdRecoveryModel ? "block" : "none" }}
      >
        <div class="modal-dialog modal-dialog-sm">
          <form noValidate autoComplete="off" onSubmit={handleSubmit(onSubmit)}>
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="cd_recovery">
                  Cd Recovery
                </h5>
                <button
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    props.handleCdClose()
                    $("#app-body").removeClass("modal-open");
                    $(".modal-backdrop").remove();
                    setValue("cd_recovery_date", null);
                    setValue("cd_recovery_amount", null);
                  }}
                ></button>
              </div>
              <div class="modal-body">
                <div className="col-12 mt-2">
                  <label>Recovery Date</label>
                  <input
                    type="date"
                    className="form-control"
                    name="cd_recovery_date"
                    {...register("cd_recovery_date", {
                      required: "This is required",
                    })}
                  />
                  {errors.cd_recovery_date && (
                    <ErrorLabel message={errors?.cd_recovery_date.message} />
                  )}
                </div>
                <div className="col-12 mt-2">
                  <label>Recovery Amount</label>
                  <input
                    type="number"
                    className="form-control"
                    name="cd_recovery_amount"
                    disabled={props?.cdSelectedIds?.length > 1 ? true : false}
                    {...register("cd_recovery_amount", {
                      //   required: "This is required",
                    })}
                  />
                  <p className="text-success ms-2 mt-1 fs-7">
                    Recovery amount will be policy gross premium
                  </p>
                </div>
              </div>
              <div class="modal-footer text-center">
                {
                  loading ?
                    <button
                      id="add_edit_cd_recovery"
                      className="btn btn-primary shadow round me-2"
                      type="submit"
                    >
                      <div className="d-flex align-items-center">
                        Apply
                        <span
                          id="add-edit-cd-recovery-loader"
                          className="spinner-border spinner-border-sm ml-half hidden"
                        ></span>
                      </div>
                    </button>
                    :
                    <button
                      id="add_edit_cd_recovery"
                      className="btn btn-primary shadow round me-2"
                      type="submit"
                    >
                      <div className="d-flex align-items-center">
                        Apply
                      </div>
                    </button>
                }
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default AddCdRecovery;
